/* tslint:disable */
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { ViewPOObraMigoAprovado } from '../../models/ViewPOObraMigoAprovado';


/**
 * Api services for the `ViewPOObraMigoAprovado` model.
 */

export class ViewPOObraMigoAprovadoApi extends BaseLoopBackApi {

  constructor(
     
  ) {
    
    super();
    
  }



  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewPOObraMigoAprovado`.
   */
  getModelName() {
    return "ViewPOObraMigoAprovado";
  }
}




// WEBPACK FOOTER //
// ./src/sdk/services/custom/ViewPOObraMigoAprovado.js